import { createFileRoute } from '@tanstack/react-router'
import { GeneralTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/general-tab'
import { useStoreProjectModalTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/modal-tab-context'

export const Route = createFileRoute(
  '/_authenticated/development/real-estate/kanban/$cardId/general',
)({
  component: GeneralTabRoute,
})

function GeneralTabRoute() {
  const tab = useStoreProjectModalTab()
  return (
    <GeneralTab
      form={tab.form}
      projectId={tab.project?.id}
      canEdit={tab.canEdit}
      canChangeStatusTo={tab.canChangeStatusTo}
      onAutoDateModeChange={tab.handleAutoDateModeChange}
      queuedPhotos={tab.queuedPhotos}
      onQueuePhoto={tab.handleQueuePhoto}
      onRemoveQueuedPhoto={tab.handleRemoveQueuedPhoto}
    />
  )
}
